import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import weekContextless from './weekContextless';

export default class Week extends weekContextless {
  // e.g. 'Sundays'
  static upperEnglishPluralLongName(dayNumber: number): MessageDescriptor {
    const pluralDaysOfWeek = [
      msg`Sundays`,
      msg`Mondays`,
      msg`Tuesdays`,
      msg`Wednesdays`,
      msg`Thursdays`,
      msg`Fridays`,
      msg`Saturdays`,
    ];

    const daysOrder = this.getDaysOrderByFirstDayOfWeek();
    return pluralDaysOfWeek[daysOrder[dayNumber]];
  }
}
